import ImagePreview from "./ImagePreview";
import ImageCroppingContainer from "./ImageCroppingContainer";
import ImageManagement from "./ImageManagement";
import { DIRECTORIES, IMAGE_SETS, IMAGE_UPLOADS } from './RecordTypes';
import { FilesystemStore } from './Contexts';

import { useEffect, useRef, useState } from 'react';
import G from './Getters';
import { useStore, useDispatch } from 'react-redux';
import usePresentSelector from './usePresentSelector';

export default function ParseImageCreator(){

  let [ focusedFsItemIds, setFocusedFsItemIds ] = useState([]);

  let selectedFilesystemItemId = focusedFsItemIds?.[0];
  const imageManagementWidth = 800;

  const store = useStore();
  const state = store.getState();


  let focusedFsItems = focusedFsItemIds.filter(x => x).map(_id => G.getRecord(state,{_id}))
  let singleFocusedImage = focusedFsItems.length === 1 && [IMAGE_SETS,IMAGE_UPLOADS].includes(focusedFsItems[0].type);
 
  let selectedDirectoryId;

  let selectedImageId;

  if( singleFocusedImage ){
    selectedImageId = G.getSelectedImageIdFromFsFocus(state,{focusedFsItemId:focusedFsItems[0]._id});
  }

  let filesystem = (

    (<div class="rel" style={{
        flexBasis:imageManagementWidth,
        background:'white',height:'100%',
        //borderRight:'1px solid #ccc',
        }}>

        
        <FilesystemStore.Provider value={{ 
          isFilesystemItemSelected:(_id) => {
            return focusedFsItemIds.includes(_id);
          },
          onFilesystemItemEvent:({
            _id,
            item,
            event
          }) => {

            const state = store.getState();

           
            
            let itemType = G.getItemType(state,_id);
            if( [IMAGE_SETS,IMAGE_UPLOADS].includes(itemType) ){
              //dispatch(A.setSelectedAnnotationsItemContext({_id}));

              setFocusedFsItemIds([_id]);  
              //;
            }else{
              //;
            }
            
          }
        }}>

          <ImageManagement/>
        </FilesystemStore.Provider>
          

        <div onMouseDown={e => {
          //setResizingImageManagement(true);
        }}
          style={{
          cursor:'ew-resize',
          top:0,
        position:"absolute", right:0, height:'100%', width:4, background:'#ccc'}}/>
        
      </div>)
  )


  let croppingContainerContent;
  if( selectedImageId ){
    croppingContainerContent = (
      <>

        <div>
          <div style={{textAlign:'left', marginBottom:20}}>
        <button style={{
          marginLeft:20,
          marginTop:50,
        }}
          class="btn-primary btn">Create</button>
      </div>

      <ImagePreview imageId={selectedImageId}/>
      {false && <ImageCroppingContainer 
        mode={""}
        //key={selectedImageId} 
        selectedImageId={selectedImageId} 
        showSidebar={false} 
        imageManagementWidth={imageManagementWidth}/>
        }
        </div>
      </>
    )
  }else{
    croppingContainerContent = (
      <div style={{fontSize:28, textAlign:'center',marginTop:200, marginLeft:100}} class="full-width">
          <div>
          Click an image on the
          <br/>
          left to annotate (crop).
          </div>

        </div>
      )
  }

  return (
    <div style={{
      height:800
    }} class="sg-row rel">


      
      
      {filesystem}
      {croppingContainerContent}



    </div>
  )
}
